import { StrictMode, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from './store/store.js';
import { getTheme, THEME_VARS } from './theme/theme.js';
import { ThemeModeProvider, useThemeMode } from './theme/ThemeModeContext.jsx';
import { ConfirmProvider } from './components/ConfirmProvider.jsx';
import App from './App.jsx';
import { initAnalytics } from './analytics.js';

initAnalytics();

/** Тема колдонуучунун аккаунтунан келет — ошондуктан Redux'тан кийин курулат */
function Shell() {
  const { mode, palette, textScale } = useThemeMode();
  const theme = useMemo(() => getTheme(palette, textScale), [palette, textScale]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={THEME_VARS} />
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
      <ToastContainer theme={mode} position="bottom-right" autoClose={4000} />
    </ThemeProvider>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeModeProvider>
          <Shell />
        </ThemeModeProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
